module.exports = __webpack_public_path__ + "static/img/laber.d00bb7e6.png";